import * as types from '../mutation-types';
import { getQuestionByCwId } from '../../assets/api/question';

// State object
const state = () => ({
  questionsByProblemId: {},
});

// Getter functions
const getters = {};

// Actions
const actions = {
  async getQuestionsByCid({ commit }, cid) {
    try {
      const { data } = await getQuestionByCwId(cid);
      const obj = {};
      data.forEach((i) => {
        if (!obj[i.problem_id]) obj[i.problem_id] = [];
        obj[i.problem_id].push(i);
      });
      obj.all = data;
      commit(types.SET_QUESTION_BY_PROBLEMID, obj);
    } catch {
      // console.log(err);
    }
  },
  removeQuestion({ commit }, { qid, pid }) {
    commit(types.REMOVE_QUESTION, { qid, pid });
  },
};

// Mutations
const mutations = {
  [types.SET_QUESTION_BY_PROBLEMID](state, payload) {
    state.questionsByProblemId = { ...state.questionsByProblemId, ...payload };
  },
  [types.REMOVE_QUESTION](state, { qid, pid }) {
    const idx = state.questionsByProblemId[pid].findIndex((i) => i.id === qid);
    state.questionsByProblemId[pid].splice(idx, 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
